import React from 'react';
import { InappmessagesButtonType, InappmessagesProps } from '../inappmessages';

import styles from '../inappmessages.module.scss';
import classNames from 'classnames';

type BodyContentProps = {
  category?: string;
  title: string;
  description: string;
  buttons: Array<InappmessagesButtonType>;
  openTarget: string;
  imageStyle: string;
  onClosePopup: Function;
  inAppMessage: InappmessagesProps;
};

const ButtonStyle = {
  TOP: {
    NONE: styles.btnHollowWhite,
    URI: styles.btnPrimary,
  },
  GRAPHIC: {
    NONE: styles.btnHollow,
    URI: styles.btnYellow,
  },
};

export function BodyContent({
  category,
  title,
  description,
  buttons,
  imageStyle,
  onClosePopup,
  openTarget,
  inAppMessage,
}: BodyContentProps) {
  const handleClick = (btn: InappmessagesButtonType) => {
    if (window.braze) {
      window.braze.logInAppMessageButtonClick(btn, inAppMessage);
      window.braze.requestImmediateDataFlush();
    }

    if (btn.clickAction === 'URI' && btn.uri) {
      window.open(btn.uri, openTarget === 'BLANK' ? '_blank' : '_self');
    }

    if (btn.clickAction === 'NONE') {
      onClosePopup();
    }
  };

  const customTitleStyle = inAppMessage.extras.mobileTextSize === 'small' ?
		styles.titleSmallMobile : inAppMessage.extras.mobileTextSize === 'medium' ?
			styles.titleMediumMobile : '';
	const customDescStyle = inAppMessage.extras.mobileTextSize === 'small' || inAppMessage.extras.mobileTextSize === 'medium' ?
		styles.descMobile : '';

  return (
    <>
      <div className={styles.contentBody}>
        {category && <span className={styles.contentStyles}>{category}</span>}
        {title && <h2 className={classNames(styles.title, customTitleStyle)}>{title}</h2>}
				{description && <p className={customDescStyle}>{description}</p>}
      </div>
      {buttons.length > 0 && (
        <div className={styles.contentFooter}>
          {buttons.map((btn) => {
            return (
              <button
                key={btn.id}
                className={classNames(styles.btn, ButtonStyle[imageStyle][btn.clickAction] || styles.primary)}
                onClick={() => {
                  handleClick(btn);
                }}
              >
                {btn.text}
              </button>
            );
          })}
        </div>
      )}
    </>
  );
}
